import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutePath } from '@percent/cause-dashboard/app/routes/Routes'
import { SavingsCalculatorContent } from '@percent/cause-dashboard/common/components/savingsCalculator/SavingsCalculatorContent'
import styles from '@percent/cause-dashboard/common/components/savingsCalculator/SavingsCalculator.module.scss'

import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

const ANALYTICS_SOURCE = 'Savings calculator page'

export function SavingsCalculatorPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: t('savingsCalculator.title') }])

  const handleComplete = () => navigate(RoutePath.PRODUCT_OFFERS)

  return (
    <div className={styles.pageCard}>
      <SavingsCalculatorContent surface="page" source={ANALYTICS_SOURCE} onComplete={handleComplete} />
    </div>
  )
}
